import {
    IAlterarUsuarioResponsavelRequest,
    IConcluirAtividadeRequest,
    IInserirHistoricoRequest,
    IListarCasoRequest,
    IListarCasoResponse,
} from "../../../Interfaces/Vendas/Caso/CasoInterface";
import {
    AlterarUsuarioResponsavelVendasService,
    AvancarEtapaVendasService,
    ConcluirAtividadeVendasService,
    InserirHistoricoVendasService,
    ListarAtributosObrigatoriosVendasService,
    ListarCasosVendasService,
    ListarEtapasVendasService,
    ListarHistoricoVendasService,
    VoltarEtapaVendasService,
} from "../../../Services/Vendas/Caso/CasoService";
import { Controller } from "../../Controller";

export async function ListarCasosVendasController(
    requestBody: IListarCasoRequest
) {
    return Controller<Array<IListarCasoResponse>>(
        ListarCasosVendasService(requestBody, false)
    );
}

export async function ExportarExcelCasosVendasController(
    requestBody: IListarCasoRequest
) {
    return Controller<Blob>(ListarCasosVendasService(requestBody, true));
}

export async function ListarEtapasVendasController() {
    return Controller(ListarEtapasVendasService());
}

export async function AvancarEtapaVendasController(
    idCaso: number,
    idEtapa: number,
    idFilaAtendimento?: number
) {
    return Controller(
        AvancarEtapaVendasService(idCaso, idEtapa, idFilaAtendimento)
    );
}

export async function VoltarEtapaVendasController(
    idCaso: number,
    idEtapa: number,
    dsComentario: number
) {
    return Controller(VoltarEtapaVendasService(idCaso, idEtapa, dsComentario));
}

export async function ListarHistoricoVendasController(idCaso: number) {
    return Controller(ListarHistoricoVendasService(idCaso));
}

export async function InserirHistoricoVendasController(
    requestBody: IInserirHistoricoRequest
) {
    return Controller(InserirHistoricoVendasService(requestBody));
}

export async function ListarAtributosObrigatoriosVendasController(
    idCaso: number
) {
    return Controller(ListarAtributosObrigatoriosVendasService(idCaso));
}

export async function ConcluirAtividadeVendasController(
    requestBody: Array<IConcluirAtividadeRequest>
) {
    return Controller(ConcluirAtividadeVendasService(requestBody));
}

export async function AlterarUsuarioResponsavelVendasController(
    requestBody: IAlterarUsuarioResponsavelRequest
) {
    return Controller(AlterarUsuarioResponsavelVendasService(requestBody));
}
